import React from "react";
import { Tooltip } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useAgentScriptMode } from "./useAgentScriptMode";
import style from "./agentScript.module.scss";

interface AgentScriptProps {
  text: string;
  className?: string;
}

export const AgentScript: React.FC<AgentScriptProps> = ({ text, className }) => {
  const mode = useAgentScriptMode();

  if (mode === "tooltip") {
    return (
      <Tooltip title={text}>
        <MessageOutlined className={`${style.infoIcon} ${className || ""}`} />
      </Tooltip>
    );
  }

  return <p className={`${style.inlineScript} ${className || ""}`}>{text}</p>;
};
